<template>
  <BlogArticleContainer>
    <p>
      As a programmer something I really like is the inifinite number of tools we had to help with every task. Do you need to do a certain
      task? Google it and you will find 3 different ways to do it at lightning speed.
    </p>
    <h3>Every professional needs tools</h3>
    Can you imagine painting the walls of your house with a brush? Would you invest in a paint roll to increase your performance? Then why
    so many professionals still do most of their work manually?

    <p>
      Like my father used to say: "Use the right tool for the right job". Investing in learning how to use the right software will increase
      our daily production and, in the long run, it will make our previous way of doing things obsolete. The first few hours of learning can
      be a headache but, how about we do the same job in half the time?
    </p>

    <p>
      "Software is eating the world", but I see so many "new" roles that continue to work manually, ignoring better ways to automate or
      improve your workflows.
    </p>

    <h2>Tools to increase your performance as a recruiter</h2>
    <h3>1. Jobboardy</h3>
    <p>
      How many hours do you spend sharing and managing job offers among the infinite web portals that exist? Before Jobboardy I remember to
      have a BIG Excel where we store the information, the account and the password of each web portal we posted our jobs in. To make it
      even messier, we keep track of every offer we sent, this many work was quickly overrun as the business grew.
    </p>

    <h4>How did we solve it?</h4>

    <p>
      That is why I created this software, being able to write a job offer and avoiding all the bureaucracy of account management is key to
      focus on your business.
    </p>

    <p>
      I'm not going to lie, I created this tool to increase our performance, it worked so well that we needed to share with other
      recruiters. What are you waiting for? Try the speedy way
      <a href="https://jobboardy.com/post-job">here</a>.
    </p>

    <h3>2. Know your worth</h3>
    <p>
      How many of the best candidates finished our process after 4 meetings because the salary range is not attractive enough for them?
      Knowing the The exact number will help you avoid these kinds of misconceptions.
    </p>
    <p>
      In a rapidly growing professional world where dozens of new "jobs" are created each year, we need to know how much our candidates
      expect to win, this will not only help us find more attractive candidates, but it will also reduce our losses as the process moves
      towards more final stages.
    </p>
    <p>
      <a rel="nofollow" href="https://www.glassdoor.com/Salaries/know-your-worth.htm">Know your worth</a>
      helps us quickly check the salary range between positions and be able to provide real information to the process.
    </p>

    <h3>3. Gender bias corrector</h3>

    <p>
      While our society advances our job offers should do to. This tool
      <a rel="nofollow" href="http://gender-decoder.katmatfield.com/">tool</a>
      helps to correct common gender miss conceptions.
    </p>
    <p>
      I often see more and more request for female candidates in positions where men had a big representation. You may have your own opinion
      on this topic but if we improve our job offers removing any sensitive missconception we can reduce the chances of top-notch talent
      skipping our offer.
    </p>

    <h3>4. Zapier</h3>

    <p>
      One of my favourites. Simply put
      <a rel="nofollow" href="https://zapier.com/">Zapier</a>
      is the way to automate everything. Zapier is a UI that allows us to connect Software and trigger actions when a concrete event occurs,
      plus it doesn't need any code at all, which makes it a tool that will raise your productivity to the next level.
    </p>

    <h4>
      Some ideas you could create within a few minutes of using Zapier.
    </h4>

    <ul>
      <li>
        Send an email everytime someone post a new Youtube video.
      </li>
      <li>
        Read your mail inbound, for any reply with the proper subject send a new email with your shedlie and contact methods.
      </li>
      <li>
        Read your mail inbound, for any reply with the proper subject send a new email with your shedlie and contact methods.
      </li>
      <li>
        Every time someone follow you on Twitter add it to a Google Sheet for later usage.
      </li>
    </ul>

    <p>
      You might think those automations are difficult to do, but they are just a few clicks away from not doing that repetitive task again
      and again. Give it a try!
    </p>
  </BlogArticleContainer>
</template>

<script>
import BlogArticleContainer from "@/blog/BlogArticleContainer";

export default {
  components: {
    BlogArticleContainer,
  },
};
</script>

<style></style>
